export const GRAMMAR_ITEM_SKILLS = ['grammar', 'meaning', 'listening'] as const;
